import { render, staticRenderFns } from "./GadgetOptions.vue?vue&type=template&id=add6d7e4&"
import script from "./GadgetOptions.vue?vue&type=script&lang=js&"
export * from "./GadgetOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports